import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import type { ReactNode } from "react";
import type { EmailDeliveryStatus } from "@/lib/email/types";
import { routes } from "@/lib/routes";
const COPY: Record<EmailDeliveryStatus, string> = {
  requested: "Der Versand wurde angefordert. Bitte prüfen Sie Ihren Posteingang und Spamordner.",
  accepted: "Die E-Mail wurde an Ihren E-Mail-Anbieter übergeben. Bitte prüfen Sie auch den Spamordner.",
  delayed: "Die Zustellung verzögert sich. Ihr E-Mail-Anbieter hat die Nachricht noch nicht angenommen.",
  failed: "Die E-Mail konnte nicht zugestellt werden. Bitte prüfen Sie Ihre Adresse.",
  unknown: "Der Zustellstatus ist derzeit nicht verfügbar. Sie können den Code trotzdem eingeben, sobald er ankommt."
};

/** Shared status and recovery copy for the standalone and inline OTP cards. */
export function OtpDeliveryNotice(t0) {
  const $ = _c(10);
  const {
    status,
    showRecovery,
    children
  } = t0;
  const t1 = COPY[status];
  let t2;
  if ($[0] !== t1) {
    t2 = <p role="status" aria-live="polite">{t1}</p>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== showRecovery) {
    t3 = showRecovery && <p>Noch kein Code? Prüfen Sie Ihre E-Mail-Adresse. Sie können sie ändern oder nach der Wartezeit einen neuen Code anfordern.{" "}<Link href={routes.content.kontakt} target="_blank" rel="noopener noreferrer" className="font-semibold underline">Hilfe erhalten</Link></p>;
    $[2] = showRecovery;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== children) {
    t4 = children && <p>{children}</p>;
    $[4] = children;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t3 || $[8] !== t4) {
    t5 = <div className="space-y-2 rounded-xl border border-outline-variant/20 bg-surface-container/50 p-3 text-sm text-on-surface leading-snug">{t2}{t3}{t4}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}